// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ToggleFullscreen_toggleButton__qhBcT","toggleIcon":"ToggleFullscreen_toggleIcon__3ar_Y"};